import { TESTIMONIALS } from '@/mocks/testimonials';

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#C4956A] text-sm"></i>
      ))}
    </div>
  );
}

function TestimonialCard({ t }: { t: typeof TESTIMONIALS[0] }) {
  return (
    <div className="bg-white rounded-2xl p-6 border border-stone-100">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
          <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
        </div>
        <div>
          <p className="text-stone-800 font-semibold text-sm">{t.name}</p>
          <p className="text-stone-400 text-xs">{t.handle}</p>
        </div>
        <div className="ml-auto">
          <StarRating count={t.rating} />
        </div>
      </div>
      <p className="text-stone-600 text-sm leading-relaxed">"{t.review}"</p>
      <p className="text-[#8A9B85] text-xs font-medium mt-3">{t.dog}</p>
    </div>
  );
}

export default function Testimonials() {
  const col1 = TESTIMONIALS.slice(0, 2);
  const col2 = TESTIMONIALS.slice(2, 4);
  const col3 = TESTIMONIALS.slice(4, 6);

  return (
    <section id="reviews" className="py-14 md:py-32 bg-[#E8EDE6]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-16">
          <span className="text-[#6B7A66] text-xs font-bold uppercase tracking-widest">Real Reviews</span>
          <h2 className="text-3xl md:text-5xl font-bold text-stone-800 mt-3 mb-3 md:mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Loved by Dog Owners Everywhere
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <div className="flex items-center gap-1">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-[#C4956A] text-lg"></i>
              ))}
            </div>
            <span className="text-stone-600 font-semibold">4.9 out of 5</span>
            <span className="text-stone-400 text-sm">· 2,400+ verified reviews</span>
          </div>
        </div>

        {/* Desktop masonry */}
        <div className="hidden md:grid grid-cols-3 gap-5">
          <div className="flex flex-col gap-5">
            {col1.map((t) => <TestimonialCard key={t.id} t={t} />)}
          </div>
          <div className="flex flex-col gap-5 mt-8">
            {col2.map((t) => <TestimonialCard key={t.id} t={t} />)}
          </div>
          <div className="flex flex-col gap-5">
            {col3.map((t) => <TestimonialCard key={t.id} t={t} />)}
          </div>
        </div>

        {/* Mobile single column — show only 3 */}
        <div className="md:hidden flex flex-col gap-4">
          {TESTIMONIALS.slice(0, 3).map((t) => <TestimonialCard key={t.id} t={t} />)}
        </div>

        <div className="text-center mt-14">
          <a
            href="#product"
            className="inline-flex items-center gap-2 bg-[#C4956A] hover:bg-[#b5845a] text-white font-bold px-8 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer text-base"
          >
            Join 10,000+ Happy Owners
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
